
    import { Component, Vue, Prop, Watch,Ref } from 'vue-property-decorator';
    import BaseVue from '@/components/BaseVue'
    import costEntryDialog from '@/components/CostEntryDialog.vue'
    import searchTransportCostDialog from '@/components/SearchTransportCostDialog.vue'
    import { Pulldown } from '../models/Pulldown'
    import { Authority } from '../models/Authority'
    import { CostList } from '../models/CostList'
    import { MonthlyCostData } from '../models/MonthlyCostData'
    import { SearchCondition } from '../models/CostListSearchCondition'
    import { LogData } from '../models/LogData'
    import { Const } from '../scripts/Const'
    import ControlManager from '../scripts/ControlManager';
    import appBar from '@/components/AppBar.vue'
    import { MsgConst } from '../scripts/MsgConst'
    import { StringUtil } from '../scripts/StringUtil'

    @Component({ components: { searchTransportCostDialog, costEntryDialog, appBar } })
    export default class CostListView extends BaseVue {
        
        //#region 変数
        @Ref('costListConfirmBtn')confirmBtn!: Vue;
        @Ref('costListApprovalBtn')approvalBtn!: Vue;
        @Ref('costListRejectBtn')rejectBtn!: Vue;

        private dialogDelete = false
        private selectedCostValue = 0
        private searchCondition: SearchCondition = new SearchCondition()
        private monthlyData: MonthlyCostData = new MonthlyCostData()
        private costList: CostList[] = []
        private targetDate = ''
        private workingYm = ''
        private selectDetail: string[] = []
        //private logs: LogData = new LogData()
        private logs: LogData[] = []
        private authority: Authority = new Authority()
        private eventNm = ''
        //コントロールごとの活性制御
        private controlManager = new ControlManager();

        //経費入力
        private showCostEntryDialog = false
        private paramDetailNo = 0
        private paramTargetDate = ''
        private paramEmpCd = ''
        //交通費検索
        private showSearchTransportCostDialog = false
        //#region 表示制御

        //フッターボタン
        private showConfirmbtn               = false;
        private showApprovalbtn              = false;
        private showRejectbtn                = false;
        private showCostEntrybtn             = false;
        private showSearchTransportCostbtn   = false;


        private showDecisionRemarks          = false;

        //#endregion

        //#region 活性制御

        //フッターボタン
        private disableConfirmbtn               = true;
        private disableApprovalbtn              = true;
        private disableRejectbtn                = true;
        private disableCostEntrybtn             = true;
        private disableSearchTransportCostbtn   = true;


        private disableCheck = false
        //#endregion

        //#region メッセージ
        private showMessage = false
        private messageType = 'info'
        private message = ''
        //#endregion

        //#region ガイダンス
        private showGuidance = false
        private guidanceType = 'info'
        private guidance = ''
	    //#endregion

        //#region ダイアログ
        private decisionDialog = false
        private confirmationDialog = false
        private title = ''
        private dialogMsg = ''
        //#endregion

        //#region スナックバー
        private showSnackbar = false
        private snackbarMsg = ''
        //#endregion

        //月次でデータを取得するかどうか
        private monthlyKbn = ''

        //#region 月次/日次表示区分
        /** 月次/日次表示区分 */
         readonly MonthlyKbn = class {
            /** 月次 */
            static readonly MONTHLY = '1';
            /** 日次 */
            static readonly DAILY = '0';
        }
        //#endregion

        //画面初期表示時かどうか
        private initialFlg:boolean

        //#region 経費一覧ヘッダー
        private headers = [
            {
                value: 'data-table-select',
                width: '40px',
                class: ' sticky-header sticky1 zindex4 white--text nowRap',
                align: 'center',
                sortable: false,
            },
            {
                text: '',
                value: 'actions',
                sortable: false,
                class: 'primary sticky-header sticky2 zindex4 white--text',
                align: 'center',
                width: '34px',
            },
            {
                text: '日付',
                sortable: false,
                value: 'targetDate',
                class: 'primary sticky-header sticky3 zindex4 white--text p-0 nowRap',
                align: 'center',
                width: '30px',
            },
            {
                text: '費目',
                sortable: false,
                value: 'costKbnNm',
                class: 'primary sticky-header white--text nowRap',
                align: 'center',
                width: '66px',
            },
            {
                text: '経路区分',
                sortable: false,
                value: 'commuteRouteKbn',
                class: 'primary sticky-header white--text nowRap',
                align: 'center',
                width: '4%',
            },
            {
                text: '領収書',
                sortable: false,
                value: 'recceiptFlg',
                class: 'primary sticky-header white--text nowRap',
                align: 'center',
                width: '4%',
            },
            {
                text: '金額',
                sortable: false,
                value: 'costAmount',
                class: 'primary sticky-header white--text nowRap',
                align: 'center',
                width: '2%',
            },
            {
                text: '備考',
                sortable: false,
                value: 'userRemarks',
                class: 'primary sticky-header white--text nowRap',
                align: 'center',
                width: '20%',
            },
            {
                text: '経路',
                sortable: false,
                value: 'passInfo',
                class: 'primary sticky-header white--text',
                align: 'center',
                width: '60%',
            },
        ]
        //#endregion

        //#endregion

        //#region イベント

        //#region 初期表示
        private async created() {

            //チェックボックス初期化
            this.selectDetail = []

            this.initialSettting();

            this.searchCondition.ym = this.$route.params.workingYm

            if (this.searchCondition.ym) {
                (this.searchCondition.ym).replace('-', '')
            }

            this.searchCondition.empCd = this.$route.params.empCd
            this.searchCondition.targetDate = this.$route.params.workingDate
            this.searchCondition.monthlyKbn = this.$route.params.monthlyKbn
            
            this.searchCondition.beforeViewName = this.$route.params.beforeViewName
            this.searchCondition.beforeViewParam1 = this.$route.params.beforeViewParam1
            this.searchCondition.beforeViewParam2 = this.$route.params.beforeViewParam2
            this.searchCondition.beforeViewParam3 = this.$route.params.beforeViewParam3
            
            this.targetDate = this.$route.params.workingDate
            this.workingYm = this.$route.params.workingYm
            this.monthlyKbn = this.$route.params.monthlyKbn

            //検索
            this.getCostList()
        }

        //#region 子画面 更新イベント
        private onUpdateDetail() {
            //経費一覧を再取得
            this.getCostList()
        }
        //#endregion

        //#endregion

        //#region　確認ボタン押下
        private clickConfirm() {
            if (this.selectDetail.length > 0) {
                //チェックしている場合
                this.eventNm = 'confirmDetail'
                this.showDecisionRemarks = false;
                this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_004,'指定した明細'))
            } else {
                //チェックしていない場合
                this.eventNm = 'confirmMonthly'
                this.showDecisionRemarks = false;
                this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_004, '経費一覧'))
            }
        }
        //#endregion

        //#region　承認ボタン押下
        private clickApproval() {
            if (this.selectDetail.length > 0) {
                //チェックしている場合
                this.eventNm = 'approvalDetail'
                this.showDecisionRemarks = true;
                this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_005,'指定した明細'))
            } else {
                //チェックしていない場合
                this.eventNm = ''
                this.openConfirmationDialog('エラー', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_016, '承認する明細'))
            }
        }
        //#endregion

        //#region　否認ボタン押下
        private clickReject() {
            if (this.selectDetail.length > 0) {
                //チェックしている場合
                this.eventNm = 'reject'
                this.showDecisionRemarks = true;
                this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_015,'指定した明細'))
            } else {
                 //チェックしていない場合

                if (this.monthlyKbn === this.MonthlyKbn.DAILY || this.costList.length > 0) {
                    //経費一覧（日次）で操作または明細が存在する場合
                    this.eventNm = ''
                    this.openConfirmationDialog('エラー', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_016, '否認する明細'))
                } else {
                    //経費一覧（月次）で操作しており、明細が0件の場合
                    this.eventNm = 'reject'
                    this.showDecisionRemarks = true;
                    this.openDialog('確認', StringUtil.stringFormat(MsgConst.COMMON.CONFIRM_015, '経費一覧'))
                }
            }
        }
        //#endregion

        //#region 編集アイコンボタン押下
        private editCostDetail(item: CostList) {

            const ymd = (this.targetDate.replace('-', '')).replace('-', '')

            //子画面のパラメータを設定
            this.paramDetailNo = item.detailNo;
            this.paramTargetDate = ymd.substring(0,6) + item.targetDate;
            this.paramEmpCd = this.searchCondition.empCd;

            if (item.costKbn === Const.CostKbn.TRANSPORT_COST) {
                this.showSearchTransportCostDialog = true;
            } else {
                this.showCostEntryDialog = true;
            }
        }
        //#endregion

        //#region その他経費ボタンクリック
        private clickShowCostEntryDialog() {
            const ymd = (this.targetDate.replace('-', '')).replace('-', '')

            //パラメータを設定
            this.paramTargetDate = ymd;
            this.paramDetailNo = 0;
            this.paramEmpCd = this.searchCondition.empCd;
            this.showCostEntryDialog = true;
        }
        //#endregion

        //#region　交（公共）ボタンクリック
        private clickShowSearchTransportCostDialog() {
            const ymd = (this.targetDate.replace('-', '')).replace('-', '')

            //パラメータを設定
            this.paramTargetDate = ymd;
            this.paramDetailNo = 0;
            this.paramEmpCd = this.searchCondition.empCd;
            this.showSearchTransportCostDialog = true;

        }
        //#endregion

        //#region 添付ダウンロードボタンクリック
        private downLoadReceipt(filePath: string, item: CostList) {
            this.downloadReceiptFile(filePath, item)
        }
        //#endregion

        //#region 経費入力ダイアログ　閉じる
        private costEntryResponse(res: boolean) {
            this.showCostEntryDialog = false
        }
        //#endregion 

        //#region 交通費検索ダイアログ　閉じる
        private costSearchResponse(res: boolean) {
            this.showSearchTransportCostDialog = false
        }
        //#endregion

        //#region 戻るボタン押下
        private clickClose() {
            this.$store.commit('navigation/POP_HISTORY') // 現在画面を削除
            const previous = this.$store.getters['navigation/lastPage'] // ひとつ前を取得

            if (previous) {
                this.$router.push({
                    name: previous.name,
                    params: {
                        workingYm: this.monthlyData.ym,
                        workingDate: this.targetDate,
                        empCd: this.monthlyData.empCd,
                        beforeViewName: this.searchCondition.beforeViewName,
                        beforeViewParam1: this.searchCondition.beforeViewParam1,
                        beforeViewParam2: this.searchCondition.beforeViewParam2,
                        beforeViewParam3: this.searchCondition.beforeViewParam3,
                        isBack: true
                    } as any
                })
            } else {
                this.$router.push({ name: 'Menu' })
            }
        }
        //#endregion

        //#endregion

        //#region プライベートメソッド  

        //#region 画面初期設定
        private initialSettting() {
            this.monthlyKbn = this.MonthlyKbn.MONTHLY;
            this.initialFlg = true;

            this.initialize();

        }
        //#endregion

        //#region 一覧取得後の表示設定
        private displaySetting(responsedData:any) {

            //権限
            this.authority = responsedData.data.authority
            //経費一覧
            this.costList = responsedData.data.searchResult
            this.monthlyData = responsedData.data.monthlyBasicData
            //ログ
            this.logs = responsedData.data.logList || []
            //表示制御
            this.displayShowControl()
            //活性制御
            this.displayDisableContorol()
            //要対応件数カウント
            this.countActionRequired()
            //ガイダンス　
            this.getGuidance()

            //日次/月次表示設定を更新
            this.monthlyKbn = responsedData.data.searchCondition.monthlyKbn

            //表示対象期間を設定
            this.targetDate = this.setTargetDate(responsedData.data.searchCondition.monthlyKbn, responsedData.data.monthlyBasicData.ym);

            //初期表示時、結果件数に応じて子画面展開
            this.setForNoResult(this.costList);

            //画面上部へスクロール
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        //#endregion

        //#region 画面初期化
        private initialize() {
            this.showConfirmbtn               = false;
            this.showApprovalbtn              = false;
            this.showRejectbtn                = false;
            this.showCostEntrybtn             = false;
            this.showSearchTransportCostbtn   = false;
            this.showDecisionRemarks = false;

            this.disableConfirmbtn = true;
            this.disableApprovalbtn = true;
            this.disableRejectbtn = true;
            this.disableCostEntrybtn = true;
            this.disableSearchTransportCostbtn = true;
            this.disableCheck = true;

            this.showGuidance = false;
            this.clearMessage();

            this.costList = [];
        }
        //#endregion

        //#region ガイダンスを表示する
        private getGuidance() {

            //何をすべきかガイダンスする
            this.showGuidance = false
            this.guidance = ''

            this.guidanceType = 'info'

            //勤務表未登録判定
            if (this.monthlyData.workingStatus === null ) {
                this.guidanceType = 'error'
                this.guidance = MsgConst.COST_LIST.ERROR_002
                this.showGuidance = true
                return
            }

            //勤務表「承認済」「締済」
            if (this.monthlyData.workingStatus === Const.MonthlyStatus.APPROVED || this.monthlyData.workingStatus === Const.MonthlyStatus.CLOSING) {
                this.guidance = MsgConst.COST_LIST.INFO_002
                this.showGuidance = true
                return
            }

            //定期申請未締
            if (this.monthlyData.trainPassStatus !== Const.TrainPassStatus.CLOSING) {
                this.guidance = MsgConst.COST_LIST.INFO_003
                this.showGuidance = true
                return
            }

            //作成中判定
            if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.MAKING) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '経費一覧'
                if (this.showApprovalbtn == true) {
                    this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_007, this.guidance)
                } else {
                    this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_008, this.guidance)
                }
                this.showGuidance = true
                return
            }

            //承認待ち判定
            if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.AWAITING_APPROVAL) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '経費一覧'
                if (this.showApprovalbtn == true) {
                    this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_001, this.guidance)
                } else {
                    this.guidance = StringUtil.stringFormat(MsgConst.COMMON.INFO_002, this.guidance)
                }
                this.showGuidance = true
                return
            }

            //承認済み判定
            if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.APPROVED) {
                this.guidance += this.guidance != '' ? '・' : ''
                this.guidance += '経費一覧'
            }
            if (this.guidance != '') {
                this.guidance = MsgConst.COMMON.INFO_003
                this.showGuidance = true
                return
            }

            //締済み判定
            if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.CLOSING && !this.authority.roleWorkingHoursAdmin) {
                this.guidance = MsgConst.COMMON.INFO_004
                this.showGuidance = true
                return
            }

            //経費一覧が差戻の場合
            if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.REMAND) {
                this.errorMessage(MsgConst.COST_LIST.ERROR_001)
            }

        }
	    //#endregion

        //#region 画面項目の表示制御
        private displayShowControl() {

            //処理前にすべて非表示状態にする
            this.showConfirmbtn               = false;
            this.showApprovalbtn              = false;
            this.showRejectbtn                = false;
            this.showCostEntrybtn             = false;
            this.showSearchTransportCostbtn   = false;
            
            this.showDecisionRemarks          = false;

            //経費一覧ステータス「未登録」「作成中」「差戻」
            //ログインユーザーまたは管理職
            if ((this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.UNREGISTERED || this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.MAKING || this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.REMAND)
                && (this.monthlyData.empCd === this.authority.loginEmpCd || (this.authority.roleManager || this.authority.roleWorkingHoursAdmin))) {

                if (this.monthlyKbn === this.MonthlyKbn.DAILY) {
                    this.showCostEntrybtn = true;
                    this.showSearchTransportCostbtn = true;
                }
            }

            //(＜＞ログインユーザー または役員)かつ（勤怠管理権限または管理職）
            if (((this.monthlyData.empCd !== this.authority.loginEmpCd) || (this.authority.empTypeCd === Const.Emptype.EXECTIVE)) && (this.authority.roleManager || this.authority.roleWorkingHoursAdmin)) {

                //経費一覧「未登録」
                //経費一覧「作成中」
                //経費一覧「差戻」
                //経費一覧「承認待ち」
                //経費一覧「承認済み」
                if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.UNREGISTERED
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.MAKING
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.REMAND
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.AWAITING_APPROVAL
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.APPROVED
                ) {
                    this.showRejectbtn = true;
                    this.showApprovalbtn = true;                 
                }
            }

            //＜＞ログインユーザーかつ（勤怠管理権限または管理職または現場リーダーまたは担当営業）
            if (this.monthlyData.empCd !== this.authority.loginEmpCd && (this.authority.roleManager || this.authority.roleLeader || this.authority.roleSales || this.authority.roleWorkingHoursAdmin)) {

                //経費一覧「未登録」
                //経費一覧「作成中」
                //経費一覧「差戻」
                //経費一覧「承認待ち」
                //経費一覧「承認済み」
                if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.UNREGISTERED
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.MAKING
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.REMAND
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.AWAITING_APPROVAL
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.APPROVED
                ) {
                    this.showConfirmbtn = true;
                }

            }

            //決裁理由
            if (this.authority.roleManager || this.authority.roleWorkingHoursAdmin) {
                if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.AWAITING_APPROVAL
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.REMAND
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.APPROVED) {
                    this.showDecisionRemarks = true;
                }
            } else {
                if (this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.AWAITING_APPROVAL
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.REMAND
                    || this.monthlyData.monthlyStatus === Const.CostMonthlyStatus.APPROVED) {
                    if (this.monthlyData.decisionRemarks) {
                        this.showDecisionRemarks = true;
                    }
                }
            }
        }
        //#endregion

        //#region　画面項目の活性制御
        private displayDisableContorol() {

            //処理前にすべて非活性状態にする
            this.disableConfirmbtn  = true;
            this.disableApprovalbtn = true;
            this.disableRejectbtn = true;
            this.disableCostEntrybtn            = true;
            this.disableSearchTransportCostbtn  = true;

            this.disableCheck = true;


            ///フッターボタン、「その他経費」「交（公共）」ボタンの活性制御
            //勤務表「作成中」「新規」「差戻」「承認待ち」「承認済み」
            if (this.monthlyData.workingStatus == Const.MonthlyStatus.NEW
                || this.monthlyData.workingStatus == Const.MonthlyStatus.MAKING
                || this.monthlyData.workingStatus == Const.MonthlyStatus.REMAND
                || this.monthlyData.workingStatus == Const.MonthlyStatus.AWAITING_APPROVAL
                || this.monthlyData.workingStatus == Const.MonthlyStatus.APPROVED) {

                //同月の定期申請「承認済」「締済」
                if (this.monthlyData.trainPassStatus == Const.TrainPassStatus.APPROVED || this.monthlyData.trainPassStatus == Const.TrainPassStatus.CLOSING) {

                    ///経費一覧

                    //「未登録」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.UNREGISTERED) {

                        this.disableApprovalbtn = false;
                        this.disableRejectbtn = false;
                        this.disableConfirmbtn = false;
                    }

                    //「作成中」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.MAKING) {

                        this.disableApprovalbtn = false;
                        this.disableRejectbtn = false;
                        this.disableConfirmbtn = false;
                    }

                    //「差戻」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.REMAND) {

                        this.disableApprovalbtn = false;
                        this.disableRejectbtn = false;
                        this.disableConfirmbtn = false;
                    }

                    //「承認待ち」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.AWAITING_APPROVAL) {

                        this.disableApprovalbtn = false;
                        this.disableRejectbtn = false;
                        this.disableConfirmbtn = false;

                    }

                    //「承認済」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.APPROVED) {

                        this.disableApprovalbtn = false;
                        this.disableRejectbtn = false;
                        this.disableConfirmbtn = false;

                    }
                }

                if (this.monthlyData.trainPassStatus == Const.TrainPassStatus.CLOSING) {
                    ///経費一覧

                    //「未登録」「作成中」「差戻」
                    if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.UNREGISTERED
                        || this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.MAKING
                        || this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.REMAND) {

                        this.disableCostEntrybtn = false;
                        this.disableSearchTransportCostbtn = false;

                    }
                }
            }

            //勤怠管理権限、管理職、現場リーダー、担当営業のいずれか
            if (this.authority.roleWorkingHoursAdmin || this.authority.roleManager || this.authority.roleLeader || this.authority.roleSales) {

                //経費一覧の従業員がログインユーザー自身でない
                if (this.monthlyData.empCd !== this.authority.loginEmpCd || this.authority.roleWorkingHoursAdmin) {

                    //経費一覧ステータス　「締済」以外
                    if (this.monthlyData.monthlyStatus !== Const.CostMonthlyStatus.CLOSING) {

                         ///一覧チェックリストの活性制御
                        this.disableCheck = false;
                    }
                }
            }
        }
        //#endregion

        //#region 経費一覧取得
        private async getCostList() {
            try {

                const data = { SearchCondition: this.searchCondition }
                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostList/Get', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (response.data.messageData.errFlg) {
                        return
                    }
                }
                //ログ
                this.logs = response.data.logList || []
                //一覧取得後の表示設定
                this.displaySetting(response)

            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
	    //#endregion

        //#region　経費一覧確認
        private async confirmMonthly() {
            try {

                const data = {
                    SearchCondition: this.searchCondition,
                    SearchResult: this.costList,
                    MonthlyBasicData: this.monthlyData
                }
                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostList/ConfirmMontly', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        this.getCostList()
                        this.selectDetail = []
                    }
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region　経費明細確認
        private async confirmDetail() {
            try {

                const data = {
                    SearchCondition: this.searchCondition,
                    SearchResult: this.costList,
                    MonthlyBasicData: this.monthlyData,
                    SelectDetail: this.selectDetail
                }

                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostList/ConfirmDetail', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        this.getCostList()
                        this.selectDetail = []
                    }
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region　経費一覧承認
        private async approvalMonthly() {
            try {
                this.disableAllFooterBtn();

                const data = {
                    SearchCondition: this.searchCondition,
                    SearchResult: this.costList,
                    MonthlyBasicData: this.monthlyData
                }

                const response = await this.$axios.post('api/CostList/ApprovalMontly', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        this.getCostList()
                        this.selectDetail = []
                    }
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region　経費明細承認
        private async approvalDaily() {
            try {
                
                const data = {
                    SearchCondition: this.searchCondition,
                    SearchResult: this.costList,
                    MonthlyBasicData: this.monthlyData,
                    SelectDetail: this.selectDetail
                }

                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostList/ApprovalDetail', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        this.getCostList()
                        this.selectDetail = []
                    }
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region　否認
        private async reject() {
            try {

                const data = {
                    SearchCondition: this.searchCondition,
                    SearchResult: this.costList,
                    MonthlyBasicData: this.monthlyData,
                    SelectDetail: this.selectDetail
                }

                this.disableAllFooterBtn();
                const response = await this.$axios.post('api/CostList/Reject', data)
                this.restoreAllFooterBtn();

                //メッセージがある場合表示
                if (response.data.messageData.messageList.length > 0) {
                    this.showMessage = true
                    this.message = response.data.messageData.messageList[0]
                    response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
                    if (!response.data.messageData.errFlg) {
                        this.getCostList()
                        this.selectDetail = []
                    }
                    //画面上部へスクロール
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    return
                }
            } catch (e) {
                console.log(e.message)
            } finally {
            }
        }
        //#endregion

        //#region ダイアログイベント
        private dialogEvent(reply: string) {
            this.avoidMultipost(async () => {
                if (reply == 'yes') {
                    //はいが押された場合
                    switch (this.eventNm) {
                        case 'confirmMonthly':
                            this.confirmMonthly()
                            break
                        case 'confirmDetail':
                            this.confirmDetail()
                            break
                        case 'approvalMonthly':
                            this.approvalMonthly()
                            break
                        case 'approvalDetail':
                            this.approvalDaily()
                            break
                        case 'reject':
                            this.reject()
                            break
                        default:
                            break
                    }
                } else {
                    //いいえが押された場合
                    switch (this.eventNm) {
                        case 'overwriteTime':
                            break
                        default:
                            break
                    }
                }
                //ダイアログを閉じる
                this.decisionDialog = false
                this.eventNm = ''
            })
        }
	//#endregion

        //#region ダイアログ
        //決定ダイアログ
        private openDialog(title: string, msg: string) {
            this.title = title
            this.dialogMsg = msg
            this.decisionDialog = true
        }
        //確認ダイアログ
        private openConfirmationDialog(title: string, msg: string) {
            this.title = title
            this.dialogMsg = msg
            this.confirmationDialog = true
        }
	    //#endregion

        //#region 要対応項目カウント
        private countActionRequired() {
            msg = ''
            this.snackbarMsg = ''

            var costDetailRemand = this.costList.filter((x) => x.detailStatus == Const.CostDetailStatus.REMAND)

            if (costDetailRemand.length > 0) {
                msg = '経費明細:'
                msg = msg + costDetailRemand.length + '件 \r\n'
            }

            if (msg && this.monthlyKbn === this.MonthlyKbn.MONTHLY) {
                this.showSnackbar = true
                this.snackbarMsg = '【本人】' + msg
            }

            //経費一覧が差戻の場合
            if (this.monthlyData.monthlyStatus == Const.CostMonthlyStatus.REMAND) {
                this.errorMessage(MsgConst.COST_LIST.ERROR_001)
            }

            var msg = ''


            //管理職ログイン
            if (this.monthlyData.empCd != this.authority.loginEmpCd && this.authority.roleManager) {
                var costDetail = this.costList.filter((x) => x.detailStatus == Const.CostDetailStatus.AWAITING_APPROVAL)


                if (costDetail.length > 0) {
                    msg = '経費明細:' + costDetail.length + '件 \r\n'
                }

                if (msg) {
                    if (this.snackbarMsg) {
                        this.snackbarMsg += '、'
                    }
                    this.snackbarMsg += '【管理職】' + msg
                }
            }

            if (this.snackbarMsg && this.monthlyKbn === this.MonthlyKbn.MONTHLY) {
                this.showSnackbar = true
            }
        }
	    //#endregion

        //#region エラーメッセージ
        private errorMessage(message: string) {
            this.showGuidance = true
            this.guidanceType = 'error'
            this.guidance = message
        }
        //#endregion

        //#region メッセージクリア
        private clearMessage() {
            this.message = ''
            this.showMessage = false
            this.snackbarMsg = ''
            this.showSnackbar = false
        }
	    //#endregion

        //#region 数値を三桁カンマで表示する
        private formatNumber(value: number): string {
            return StringUtil.formatNumber(value.toString());
        }
        //#endregion

        //#region 「経路」列の表示設定
        private setTrainCourse(startStation: string, endStation: string) {
            if (startStation !== '') {
                return (startStation + '~' + endStation)
            } else {
                return ''
            }
        }
        //#endregion

        //#region 登録交通費が最安値か否かで行の色を設定する
        private getRowClass(item: CostList) {

            if (item.costKbn === Const.CostKbn.TRANSPORT_COST) {
                if (item.lowestPrice < item.costAmount) {
                    return 'notLowestPrice-row';
                }
                else {
                    return '';
                }
            } else {
                return '';
            }
        }
        //#endregion

        //#region 明細ステータスに応じた　日付列の色制御
        private detailStatusColor(status: string, logcount: string) {

            if (status == Const.CostDetailStatus.REMAND) {
                //差戻
                return 'colorRed s px-1 text-center sticky3'
            } else if (status == Const.CostDetailStatus.AWAITING_APPROVAL) {
                //申請中
                return 'colorOrange  px-1 text-center sticky3'
            } else if (status == Const.CostDetailStatus.MAKING) {
                //作成中
                return 'colorGrey px-1 text-center sticky3'
            } else if (logcount) {
                //ログ情報がある場合
                return 'colorGreen px-1 text-center sticky3'
            } else {
                return 'colorWhite px-1 text-center sticky3'
            }
            
        }
        //#endregion

        //#region 添付ファイルをダウンロードする
        async downloadReceiptFile(filename: string, item: CostList) {

            try {
                await this.$axios({
                    url: 'api/CostEntryDialog/DownloadReceiptFile',
                    method: 'GET',
                    params: {
                        fileName: filename,
                        empCd: this.monthlyData.empCd,
                        year: (this.monthlyData.ym).substring(0,4),
                        month: (this.monthlyData.ym).substring(4, 6),
                        date: item.targetDate,
                        detailNo: item.detailNo.toString(),
                    },
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });

            } catch (error) {
                this.showMessage = true
                this.message = StringUtil.stringFormat(MsgConst.COMMON.ERROR_004, '出力')
                this.messageType = 'error'
            }
        }
        //#endregion

        //#region 交通費以外の経費の領収書有無を検証
        private checkUploadReceipt(costlist: CostList[]):　string {

            //添付のない明細リスト
            const list: string[] = [];

            costlist.forEach(item => {
                //「タクシー」「宿泊」「日当」「その他」の経費で、添付ファイルなしかどうか
                if ([
                    Const.CostKbn.ACCOMONDATION_FEE,
                    Const.CostKbn.DAILY_ALLOWANCE,
                    Const.CostKbn.TAXI,
                    Const.CostKbn.OTHER
                    ].includes(item.costKbn) && !item.receiptInfo) {
                    list.push(item.targetDate);
                }
            });

            if (list.length > 0) {
                return StringUtil.stringFormat(MsgConst.COST_LIST.CONFIRM_001, list.join('、'));
            }

            return '';
        }
        //#endregion

        //#region 表示対象期間を設定する
        private setTargetDate(monthlyKbn: string, ym: string): string {
            if (monthlyKbn === this.MonthlyKbn.MONTHLY) {

                if (ym) {
                    return (ym.substring(0, 4) + '-' + ym.substring(4, 6));
                }

                return '';

            } else if (monthlyKbn === this.MonthlyKbn.DAILY) {

                let date = this.targetDate.replace('-', '').replace('-', '');

                return (date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8));
            }

            return ''

        }
        //#endregion

        //#region 明細0件の場合に子画面を展開する
        private setForNoResult(costList: CostList[]) {

            if (costList.length > 0) {
                this.initialFlg = false;
            }

            //画面初期表示で結果０のとき、交通費検索ダイアログを開く（日次一覧の場合のみ、ステータス「未申請」）
            if (costList.length === 0 && this.initialFlg) {

                if (this.monthlyKbn === this.MonthlyKbn.DAILY
                    && this.monthlyData.monthlyStatus !== Const.CostMonthlyStatus.AWAITING_APPROVAL
                    && this.monthlyData.monthlyStatus !== Const.CostMonthlyStatus.APPROVED
                    && this.monthlyData.monthlyStatus !== Const.CostMonthlyStatus.CLOSING
                    && (this.monthlyData.trainPassStatus === Const.TrainPassStatus.CLOSING)
                    && (this.monthlyData.workingStatus === Const.MonthlyStatus.NEW
                        || this.monthlyData.workingStatus === Const.MonthlyStatus.UNREGISTERED
                        || this.monthlyData.workingStatus === Const.MonthlyStatus.MAKING
                        || this.monthlyData.workingStatus === Const.MonthlyStatus.REMAND)
                )
                {
                    if ((this.monthlyData.empCd === this.authority.loginEmpCd || (this.authority.roleManager || this.authority.roleWorkingHoursAdmin))) {
                        //交通費検索ダイアログを開く
                        this.clickShowSearchTransportCostDialog();
                    }
                }

                this.initialFlg = false;
            }
        }
        //#endregion

        //#region すべてのフッターボタンを一時非活性状態にする
        private disableAllFooterBtn() {
            this.$nextTick(() => {
                this.controlManager.disableControl(this.confirmBtn);
                this.controlManager.disableControl(this.approvalBtn);
                this.controlManager.disableControl(this.rejectBtn);
            });
        }
        //#endregion

        //#region すべてのフッターボタンを一時非活性解除する
        private restoreAllFooterBtn() {
            this.$nextTick(() => {
                this.controlManager.restoreControl(this.confirmBtn);
                this.controlManager.restoreControl(this.approvalBtn);
                this.controlManager.restoreControl(this.rejectBtn);
            });

        }
        //#endregion

        //#endregion
    }
